import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqItems = [
  { id: 1, qKey: "contact.faq.q1", aKey: "contact.faq.a1", icon: "ri-home-4-line" },
  { id: 2, qKey: "contact.faq.q2", aKey: "contact.faq.a2", icon: "ri-money-cny-circle-line" },
  { id: 3, qKey: "contact.faq.q3", aKey: "contact.faq.a3", icon: "ri-calendar-check-line" },
  { id: 4, qKey: "contact.faq.q4", aKey: "contact.faq.a4", icon: "ri-tools-line" },
  { id: 5, qKey: "contact.faq.q5", aKey: "contact.faq.a5", icon: "ri-building-line" },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-14 md:py-20 bg-warm-gray">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="tag-label mb-3 inline-block">{t("contact.faq.label")}</span>
          <h2 className="mb-3">{t("contact.faq.title")}</h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`bg-white rounded-xl border transition-all duration-300 overflow-hidden ${
                  isOpen ? "border-champagne/40 shadow-sm" : "border-warm-gray/20 hover:border-champagne/20"
                }`}
                style={{ animationDelay: `${index * 80}ms` }}
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-start gap-3 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer group"
                >
                  <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 mt-0.5 transition-all duration-300 ${
                    isOpen
                      ? "bg-champagne text-graphite"
                      : "bg-champagne/10 text-champagne group-hover:bg-champagne/20"
                  }`}>
                    <i className={`${item.icon} text-base`} />
                  </span>
                  <span className={`font-semibold leading-snug flex-1 transition-colors duration-300 ${
                    isOpen ? "text-graphite" : "text-graphite group-hover:text-champagne"
                  } text-base`}>
                    {t(item.qKey)}
                  </span>
                  <span className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 mt-0.5 transition-all duration-300 ${
                    isOpen
                      ? "bg-champagne text-graphite rotate-0"
                      : "bg-warm-gray/30 text-medium-gray group-hover:bg-champagne/10 group-hover:text-champagne"
                  }`}>
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line text-base transition-transform duration-300`} />
                  </span>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-400 ${
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-5 md:px-6 md:pb-6 pl-[3.25rem] md:pl-[3.75rem]">
                    <div className="pt-1 border-l-2 border-champagne/20 pl-4">
                      <p className="text-medium-gray text-base leading-relaxed">
                        {t(item.aKey)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}